var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 18.6558C35.0021 21.4256 34.1826 24.1339 32.6451 26.4378C31.1076 28.7418 28.9212 30.5379 26.3626 31.5989C23.804 32.6598 20.9881 32.938 18.2714 32.3981C15.5547 31.8583 13.0591 30.5247 11.1005 28.5661C9.14192 26.6075 7.80833 24.112 7.26848 21.3952C6.72864 18.6785 7.0068 15.8627 8.06777 13.304C9.12874 10.7454 10.9248 8.55905 13.2288 7.02154C15.5327 5.48402 18.241 4.66449 21.0108 4.66663C24.7201 4.6695 28.2766 6.14428 30.8995 8.76713C33.5223 11.39 34.9971 14.9465 35 18.6558Z",
    fill: "#F24E68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3711 34.1363C16.0636 34.1363 16.0636 21.2307 16.0636 21.2307C16.0636 17.8079 17.3211 14.5253 19.5595 12.105C21.7979 9.68476 24.8338 8.32507 27.9994 8.32507C31.165 8.32507 34.2009 9.68476 36.4393 12.105C38.6777 14.5253 39.9353 17.8079 39.9353 21.2307C39.9353 21.2307 39.9353 34.1363 41.6277 34.1363H14.3711Z",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34.1362H43",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5381 34.1362C34.5381 36.011 33.8493 37.809 32.6233 39.1346C31.3972 40.4603 29.7344 41.205 28.0005 41.205C26.2666 41.205 24.6037 40.4603 23.3777 39.1346C22.1517 37.809 21.4629 36.011 21.4629 34.1362",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 8.31313V5",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.2e9d26e699feecdc83f735751b3ee4d8.svg";
export { ForwardRef as ReactComponent };